<p-dialog 
  [visible]="showDialog()" 
  [modal]="true" 
  [dismissableMask]="true"
  [style]="{width: '90vw', maxWidth: '800px'}"
  [header]="settingsType() === 'mastery' ? 'General Mastery Settings' : 'General Maintenance Settings'"
  (visibleChange)="onVisibleChange($event)"
  [closable]="true">
  
  @if (isLoading()) {
    <app-loading-indicator />
  } @else {
    @if (settingsType() === 'mastery') {
      <div class="general-settings-content">
        @if (generalMasteryCriteria()) {
          <div class="settings-section">
            <h4>Mastery Criteria Values</h4>
            <div class="setting-item">
              <label><strong>Response Percentage:</strong></label>
              <span>{{ generalMasteryCriteria()?.ResponsePercentage ?? 'N/A' }}%</span>
            </div>
            <div class="setting-item">
              <label><strong>Consecutive Days:</strong></label>
              <span>{{ generalMasteryCriteria()?.ConsecutiveDays ?? 'N/A' }}</span>
            </div>
            <div class="setting-item">
              <label><strong>First Trial Independent:</strong></label>
              <span>{{ generalMasteryCriteria()?.FirstTrialIndependent ? 'Yes' : 'No' }}</span>
            </div>
          </div>
        } @else {
          <p>No general mastery criteria found.</p>
        }
      </div>
    } @else {
      <div class="general-settings-content">
        @if (generalMaintenanceCriteria()) {
          <div class="settings-section">
            <h4>Maintenance Settings</h4>
            @if (generalMaintenanceCriteria()?.MaintenanceCriteriaSetting) {
              <div class="setting-item">
                <label><strong>Maintenance Level When From Probe:</strong></label>
                <span>{{ getMaintenanceLevelName(generalMaintenanceCriteria()?.MaintenanceCriteriaSetting?.MaintenanceLevelIDWhenFromProbe) }}</span>
              </div>
              <div class="setting-item">
                <label><strong>Maintenance Level When From Acquisition:</strong></label>
                <span>{{ getMaintenanceLevelName(generalMaintenanceCriteria()?.MaintenanceCriteriaSetting?.MaintenanceLevelIDWhenFromAquisition) }}</span>
              </div>
            }
          </div>

          @if (generalMaintenanceCriteria()?.MaintenanceCriterias && generalMaintenanceCriteria()!.MaintenanceCriterias!.length > 0) {
            <div class="settings-section">
              <h4>Maintenance Level Criteria</h4>
              @for (criteria of generalMaintenanceCriteria()!.MaintenanceCriterias!; track criteria.ID) {
                <div class="maintenance-level-section">
                  <h5>{{ getMaintenanceLevelName(criteria.MaintenanceLevelID) }}</h5>
                  
                  <div class="criteria-group">
                    <h6>Promotion Criteria</h6>
                    <div class="setting-item">
                      <label><strong>Promotion Needed:</strong></label>
                      <span>{{ criteria.PromotionNeeded ?? 'N/A' }} of {{ criteria.PromotionTotal ?? 'N/A' }}</span>
                    </div>
                    <div class="setting-item">
                      <label><strong>Target Status When Promoting:</strong></label>
                      <span>{{ getTargetStatusName(criteria.TargetStatusIDWhenPromoting) }}</span>
                    </div>
                    <div class="setting-item">
                      <label><strong>Maintenance Level When Promoting:</strong></label>
                      <span>{{ getMaintenanceLevelName(criteria.MaintenanceLevelIDWhenPromoting) }}</span>
                    </div>
                  </div>

                  <div class="criteria-group">
                    <h6>Demotion Criteria</h6>
                    <div class="setting-item">
                      <label><strong>Demotion Needed:</strong></label>
                      <span>{{ criteria.DemotionNeeded ?? 'N/A' }} of {{ criteria.DemotionTotal ?? 'N/A' }}</span>
                    </div>
                    <div class="setting-item">
                      <label><strong>Target Status When Demoting:</strong></label>
                      <span>{{ getTargetStatusName(criteria.TargetStatusIDWhenDemoting) }}</span>
                    </div>
                    <div class="setting-item">
                      <label><strong>Maintenance Level When Demoting:</strong></label>
                      <span>{{ getMaintenanceLevelName(criteria.MaintenanceLevelIDWhenDemoting) }}</span>
                    </div>
                  </div>
                  <hr />
                </div>
              }
            </div>
          }
        } @else {
          <p>No general maintenance criteria found.</p>
        }
      </div>
    }
  }
</p-dialog>
